type FaceSheetTableHeader = {
  title: string;
  key: string;
  nowrap?: boolean;
  width?: string;
};

// width で各列の固定幅を指定する（テーブルは table-layout: fixed で描画され、
// 長文はセル内で折り返す）。幅の調整はここで行う。
export const faceSheetTableHeaders: FaceSheetTableHeader[] = [
  { title: "ID", key: "id", nowrap: true, width: "88px" },
  { title: "セイメイ", key: "nameKana", nowrap: true, width: "140px" },
  { title: "ユーザーの生年月日", key: "userBirthday", nowrap: true, width: "120px" },
  { title: "子の生年月日", key: "childBirthday", nowrap: true, width: "120px" },
  { title: "郵便番号", key: "postalCode", width: "140px" },
  { title: "クーポン名", key: "couponName", nowrap: true, width: "160px" },
  { title: "ステータス", key: "status", nowrap: true, width: "120px" },
  { title: "未対応アラート", key: "unhandledAlert", nowrap: true, width: "140px" },
  { title: "履歴", key: "history", width: "200px" },
  { title: "最新イベント日時", key: "updatedAt", nowrap: true, width: "140px" }
];